import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';
import { getApostatudoRequestHeaders } from '~/utils/apostatudo/get-apostatudo-request-headers';

export const useStoryTracking = () => {
  // Controla quais IDs já tiveram view registrada nesta sessão de abertura
  const viewedIds = new Set<string>();

  const trackClick = (id: string) => {
    fetch(`${getApostatudoApiUrl()}/stories/${id}/click`, {
      method: 'POST',
      headers: { Accept: 'application/json', ...getApostatudoRequestHeaders() },
    }).catch(() => {
      // Silencia erros — tracking não deve bloquear a navegação
    });
  };

  const trackView = (id: string) => {
    if (viewedIds.has(id)) return;
    viewedIds.add(id);

    fetch(`${getApostatudoApiUrl()}/stories/${id}/view`, {
      method: 'POST',
      headers: { Accept: 'application/json', ...getApostatudoRequestHeaders() },
    }).catch(() => {
      // Silencia erros — tracking não deve bloquear exibição
    });
  };

  return { trackClick, trackView };
};
